import React from 'react';
import { Typography } from '@mui/material';

export const SectionLabel = ({ children, sx }) => (
  <Typography
    variant="body2"
    sx={{
      fontWeight: 700,
      color: 'text.primary',
      mb: 1.5,
      fontSize: '0.875rem',
      ...sx,
    }}
  >
    {children}
  </Typography>
);

export const SubLabel = ({ children, required, sx }) => (
  <Typography
    variant="body2"
    sx={{
      fontWeight: 400,
      color: 'text.primary',
      mb: 0.75,
      fontSize: '0.875rem',
      ...sx,
    }}
  >
    {children}
    {required && (
      <Typography component="span" color="error" sx={{ ml: 0.25 }}>
        *
      </Typography>
    )}
  </Typography>
);

const FormFieldLabel = ({ children, required, sx }) => (
  <Typography
    variant="body2"
    sx={{
      fontWeight: 700,
      color: 'text.primary',
      mb: 0.75,
      fontSize: '0.875rem',
      ...sx,
    }}
  >
    {children}
    {required && (
      <Typography component="span" color="error" sx={{ ml: 0.25 }}>
        *
      </Typography>
    )}
  </Typography>
);

export default FormFieldLabel;
